export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/deleteSection',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['courseById'],
       
    })
